/**
 * Get proxied image URL to bypass CORS issues
 * @param {string} originalUrl - Original external image URL
 * @returns {string} - Proxied URL through our backend
 */
export function getProxiedImageUrl(originalUrl) {
  if (!originalUrl) return '';
  
  // If it's already a relative URL or from our domain, return as-is
  if (originalUrl.startsWith('/') || originalUrl.startsWith(window.location.origin)) {
    return originalUrl;
  }
  
  // Use backend proxy for external images
  const backendUrl = process.env.REACT_APP_BACKEND_URL || '';
  return `${backendUrl}/api/proxy-image?url=${encodeURIComponent(originalUrl)}`;
}
